// extracted by mini-css-extract-plugin
export default {"selector":"Vca","disabled":"Wca","hed":"Xca","selected":"Yca","subHed":"Zca","standard":"aea","flavor":"bea","flavorImage":"cea","long":"eea"};
    if(module.hot) {
      // 1737143665350
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  